/* Consent + consent-gated marketing pixel loader.

   First-party analytics (attribution + funnel events to our own backend) is
   essential and always on. Third-party RETARGETING pixels are DISABLED by
   default and only load when ALL of these are true:
     1. marketing config enables the pixel and provides an ID (none by default)
     2. the visitor has granted marketing consent
   With no pixel IDs configured, nothing third-party ever loads. */

const CONSENT_KEY = "airo_consent";

export function getConsent() {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
}
export function setConsent(value) {
  try { localStorage.setItem(CONSENT_KEY, value); } catch { /* ignore */ }
  if (value === "granted") loadPixels(window.__AIRO_MKT__ || {});
}
export function hasMarketingConsent() {
  return getConsent() === "granted";
}

const loaded = new Set();

function inject(src, id) {
  if (loaded.has(id)) return;
  loaded.add(id);
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
}

/* Loads retargeting pixels ONLY when configured + consented. No-op otherwise. */
export function loadPixels(cfg = {}) {
  if (!cfg || cfg.retargeting_enabled !== true) return;   // disabled by default
  if (!hasMarketingConsent()) return;                     // consent required
  const p = cfg.pixels || {};
  if (p.ga4_measurement_id) {
    inject(`https://www.googletagmanager.com/gtag/js?id=${p.ga4_measurement_id}`, "ga4");
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    gtag("js", new Date());
    gtag("config", p.ga4_measurement_id);
    window.gtag = gtag;
  }
  if (p.google_ads_id) {
    inject(`https://www.googletagmanager.com/gtag/js?id=${p.google_ads_id}`, "gads");
  }
  if (p.meta_pixel_id) {
    // Meta pixel bootstrap (only runs when an ID is present + consent granted)
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", p.meta_pixel_id);
    window.fbq("track", "PageView");
    loaded.add("meta");
  }
}

/* Fetch public marketing config once, then attempt to load pixels (still gated). */
export async function initMarketingConsent() {
  try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/marketing/config`);
    const cfg = await res.json();
    window.__AIRO_MKT__ = cfg;
    if (hasMarketingConsent()) loadPixels(cfg);
    return cfg;
  } catch {
    return { retargeting_enabled: false, consent_required: true, pixels: {} };
  }
}
